<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.5 12.5005V18.7505C27.5 25.0005 25 27.5005 18.75 27.5005H11.25C5 27.5005 2.5 25.0005 2.5 18.7505V11.2505C2.5 5.00049 5 2.50049 11.25 2.50049H17.5" stroke="#F0783B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M27.5 12.5005H22.5C18.75 12.5005 17.5 11.2505 17.5 7.50049V2.50049L27.5 12.5005Z" stroke="#F0783B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.75 16.2495H16.25" stroke="#F0783B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.75 21.2505H13.75" stroke="#F0783B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
